import { render, staticRenderFns } from "./RssWidgetPanel.vue?vue&type=template&id=e516f626&scoped=true"
import script from "./RssWidgetPanel.vue?vue&type=script&lang=js"
export * from "./RssWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./RssWidgetPanel.vue?vue&type=style&index=0&id=e516f626&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e516f626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e516f626')) {
      api.createRecord('e516f626', component.options)
    } else {
      api.reload('e516f626', component.options)
    }
    module.hot.accept("./RssWidgetPanel.vue?vue&type=template&id=e516f626&scoped=true", function () {
      api.rerender('e516f626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/RssWidgetPanel.vue"
export default component.exports